import { useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { change, reduxForm, submit } from "redux-form";
import DateService from "utils/date.util";
import LocalStorage from "utils/localstorage.util";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import PersistReduxForm from "components/organisms/PersistReduxForm";
import ButtonLoading from "components/atoms/ButtonLoading";
import ObjectService from "utils/object.util";
import { useTranslation } from "react-i18next";

import Date from "assets/icons/Date";
import PaymentMethod from "components/templates/PaymentMethod/PaymentMethod";
import MapCircle from "assets/map-circle.svg";
import MapPin from "assets/map-pin.svg";
import { MODAL, modalActions } from "redux/slices/modal";
import PlusIcon from "assets/icons/plus-btn.svg";

const Checkout = ({ handleSubmit, form }: any) => {
  const { t } = useTranslation("translation");
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const selected = useAppSelector((state) => state.payment.selected);
  const submitLoader = useAppSelector((state) => state.booking.loading);
  const classsPrice = useAppSelector((state) => state.classes.classsPrice);
  const discount = useAppSelector(
    (state) => state.form?.[form]?.values?.discount
  );
  const discount_type = useAppSelector(
    (state) => state.form?.[form]?.values?.discount_type
  );
  const coupon_code = useAppSelector(
    (state) => state.form?.[form]?.values?.coupon_code
  );
  const is_yelo_points = useAppSelector(
    (state) => state.form?.[form]?.values?.is_yelo_points
  );
  const searchTripFormValues = useAppSelector(
    (state) => state.form?.PickUpForm?.values
  );
  const distance = useAppSelector(
    (state) => state.form?.SearchTripForm?.values?.distance
  );

  const additional_info = useAppSelector(
    (state) => state.form?.["AdditionalInfoForm"]?.values
  );

  let bookingInfo = searchTripFormValues;
  const bookingFormPayload = LocalStorage.getItem("BookingFormPayload");

  const [price_details, setPriceDetails] = useState({
    discount_amount: 0,
    total: classsPrice.price_details.brutto,
  });

  useEffect(() => {
    if (!user) return;
      dispatch(change(form, "title", user?.title));
      dispatch(change(form, "first_name", user?.first_name));
      dispatch(change(form, "last_name", user?.last_name));
      dispatch(change(form, "email", user?.email));
    dispatch(change(form, "phone", { value: user?.phone }));

      dispatch(
        change(form, "pickup_sign", ObjectService.getFullName(user, false))
      );

    // if (!user?.billing_address) return;

    // const {
    //   company,
    //   first_name,
    //   last_name,
    //   address,
    //   postal_number,
    //   city,
    //   country,
    // } = user?.billing_address;
    // dispatch(change(form, "billing_address.company", company));
    // dispatch(change(form, "billing_address.first_name", first_name));
    // dispatch(change(form, "billing_address.last_name", last_name));
    // dispatch(change(form, "billing_address.address", address));
    // dispatch(change(form, "billing_address.postal_number", postal_number));
    // dispatch(change(form, "billing_address.city", city));
    // dispatch(change(form, "billing_address.country", country));
  }, [user]);

  useEffect(() => {
    const card_id = selected.card ? selected.card.card_id : "";
    dispatch(change(form, "card_id", card_id));
    dispatch(change(form, "payment_type", selected.payment_type));
  }, [selected, dispatch, form]);

  useEffect(() => {
    let total = classsPrice.price_details.brutto;
    let details = {
      total,
      discount_amount: 0,
    };
    let discount_amount =
      discount_type === "percentage" ? (total / 100) * discount : discount;
    let diff = details.total - discount_amount;

    if (discount_amount > 0) {
      if (diff < 0) {
        details.discount_amount = details.total;
        details.total = 0;
      } else {
        details.total = diff;
        details.discount_amount = discount_amount;
      }
    } else {
      details.total = details.total + details.discount_amount;
      details.discount_amount = 0;
    }

    setPriceDetails(details);
  }, [
    user,
    is_yelo_points,
    discount,
    discount_type,
    classsPrice.price_details.brutto,
  ]);

  useEffect(() => {
    dispatch(change(form, "class_id", classsPrice.class_id));
  }, [classsPrice, dispatch, form]);

  useEffect(() => {
    if (!bookingInfo) return;

    for (const key in bookingInfo) {
      if (Object.prototype.hasOwnProperty.call(bookingInfo, key)) {
        const element = bookingInfo[key];
        dispatch(change(form, key, element));
      }
    }
  }, [dispatch, bookingInfo, form]);


  const airport = searchTripFormValues?.pickup?.details?.airport;

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={4}>
                   <Grid item xs={12} md={4}>
          <Stack gap={2} mb={3}>
            <Box
              p={1}
              bgcolor={"#ffffff"}
              border={"1px solid #DEE2E9"}
              borderRadius={"16px"}
            >
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <Box
                  width={"100px"}
                  height={"50px"}
                  padding={"8px"}
                  bgcolor={"#F2F2F7"}
                  borderRadius={"16px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <img
                    src={classsPrice.class_image}
                    alt=""
                    style={{ objectFit: "contain" }}
                  />
                </Box>
                <Box>
                  <Typography
                    fontSize={"14px"}
                    mt={0}
                    mb={0.5}
                    fontWeight={600}
                  >
                    {classsPrice.class_name}
                  </Typography>
                  <Typography
                    fontSize={"12px"}
                    color={"#939399"}
                    fontWeight={300}
                  >
                    {classsPrice.vehicle_name}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Box
              p={2}
              bgcolor={"#ffffff"}
              border={"1px solid #DEE2E9"}
              borderRadius={"16px"}
            >
              {bookingFormPayload?.trip_type === "hourly" ? (
                ""
              ) : (
                <Stack
                  gap={2}
                  marginBottom="16px"
                  paddingBottom={"8px"}
                  direction={"row"}
                  borderBottom={"1px solid #ECEBF2"}
                  justifyContent={"space-between"}
                >
                  <Stack
                    borderRadius={"16px"}
                    direction={"row"}
                    alignItems={"center"}
                    gap={1}
                  >
                    <Date />
                    {DateService.getShortDateString(
                      bookingFormPayload.time_stamp
                    )}
                    , {DateService.getTimeString(bookingFormPayload.time_stamp)}
                  </Stack>
                  <Typography
                    fontSize={"14px"}
                    fontWeight={400}
                    color={"#939399"}
                  >
                    {/* {t("distance")}:{" "} */}
                    <span style={{ color: "#0a0a0e" }}>
                      {distance} {t("km")}
                    </span>
                  </Typography>
                </Stack>
              )}
              <Grid container spacing={2.5}>
                <Grid item xs={12}>
                  <Stack direction={"row"} gap={1} position={"relative"}>
                    <Box
                      bgcolor={"#FFF3FA"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      borderRadius={"25px"}
                      width={"32px"}
                      height={"32px"}
                      minWidth={"32px"}
                      minHeight={"32px"}
                      position={"relative"}
                      zIndex={1}
                    >
                      <img src={MapCircle} alt="." />
                    </Box>
                    <Box
                      top={0}
                      bottom={"-24px"}
                      zIndex={0}
                      left={"16px"}
                      position={"absolute"}
                      borderLeft={"1px dashed #ECEBF2"}
                    ></Box>
                    <div>
                      <Typography fontSize={"14px"} fontWeight={600}>
                    {searchTripFormValues?.pickup?.details?.name}
                      </Typography>
                  <Typography
                    color={"#939399"}
                        fontSize={"14px"}
                        fontWeight={300}
                  >
                    {searchTripFormValues?.pickup?.value}
                  </Typography>
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={"row"} gap={1}>
                    <Box
                      bgcolor={"#FFF3FA"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      borderRadius={"25px"}
                      width={"32px"}
                      height={"32px"}
                      minWidth={"32px"}
                      minHeight={"32px"}
                      position={"relative"}
                      zIndex={1}
                    >
                      <img src={MapPin} alt="!" />
                    </Box>
                    <div>
                      <Typography fontSize={"14px"} fontWeight={600}>
                    {bookingFormPayload?.trip_type === "hourly"
                      ? `${searchTripFormValues?.duration} ${t("hours")}`
                      : searchTripFormValues?.destination?.details?.name}
                  </Typography>
                  <Typography
                    color={"#939399"}
                        fontSize={"14px"}
                        fontWeight={300}
                  >
                    {bookingFormPayload?.trip_type === "hourly"
                      ? `Incl. ${searchTripFormValues?.duration * 40} km`
                      : searchTripFormValues?.destination?.value}
                  </Typography>
                    </div>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box
              p={2}
              bgcolor={"#ffffff"}
              border={"1px solid #DEE2E9"}
              borderRadius={"16px"}
              className="checkoutSummary"
            >
              <Typography
                mb={1.5}
                fontSize={"16px"}
                fontWeight={600}
                textTransform={"capitalize"}
              >
                {t("guest")}
              </Typography>

                  <Typography
                component={"p"}
                    color={"#939399"}
                fontSize={"12px"}
                mb={0.5}
              >
                {t("pickUpSign")}
              </Typography>
              <Typography component={"p"}>
                {additional_info?.pickup_sign}
              </Typography>
              {airport && (
                <>
                  <Typography
                    component={"p"}
                    color={"#939399"}
                    fontSize={"12px"}
                    mt={1.5}
                    mb={0.5}
                  >
                    {t("Flight Number")}
                  </Typography>
                  <Typography component={"p"}>
                    {additional_info?.flight_number}
                  </Typography>
                </>
              )}
            </Box>

            {bookingFormPayload?.isStripe && (
              <Box
                bgcolor={"#ffffff"}
                borderRadius={"16px"}
                position={"relative"}
              >
                <Typography
                  mb={1.5}
                  fontSize={"16px"}
                  fontWeight={600}
                  textTransform={"capitalize"}
                >
                  {t("paymentMethod")}
                </Typography>
                <PaymentMethod />
              </Box>
            )}

            <Box
              p={2}
              bgcolor={"#ffffff"}
              border={"1px solid #DEE2E9"}
              borderRadius={"16px"}
              className="checkoutSummary"
            >
              <Typography
                mb={1.5}
                fontSize={"16px"}
                fontWeight={600}
                textTransform={"capitalize"}
              >
                {t("checkoutSummary")}
              </Typography>

              <Stack gap={1}>
                {price_details.discount_amount > 0 ? (
                  <>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      gap={1}
                    >
                      <Typography fontSize={"14px"} fontWeight={300}>
                        {t("subtotalInclVat")}
                      </Typography>
                      <Typography fontSize={"14px"} fontWeight={600}>
                        {classsPrice.price_details.brutto.toFixed?.(2)}{" "}
                        {classsPrice.price_details.currency_sign}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      gap={1}
                    >
                      <Typography fontSize={"14px"} fontWeight={300}>
                        {t("BooingDiscount")}
                        {discount_type === "percentage" ? `( ${discount}% )` : ""}
                      </Typography>
                      <Typography fontSize={"14px"} fontWeight={600}>
                        - {price_details.discount_amount.toFixed?.(2)}{" "}
                        {classsPrice.price_details.currency_sign}
                      </Typography>
                    </Stack>
                  </>
                ) : (
                  <>
                    {classsPrice.price_details.netto > 0 && (
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        gap={1}
                      >
                        <Typography fontSize={"14px"} fontWeight={300}>
                          {t("netPrices")}
                        </Typography>
                        <Typography fontSize={"14px"} fontWeight={600}>
                          {classsPrice.price_details.netto.toFixed?.(2)}{" "}
                          {classsPrice.price_details.currency_sign}
                        </Typography>
                      </Stack>
                    )}
                    {classsPrice.price_details.VAT > 0 && (
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        gap={1}
                      >
                        <Typography
                          fontSize={"14px"}
                          fontWeight={300}
                          textTransform={"uppercase"}
                        >
                          {t("bookingVat")} ({classsPrice.price_details.VAT}%)
                        </Typography>
                        <Typography fontSize={"14px"} fontWeight={600}>
                          {(
                            classsPrice.price_details.brutto -
                            classsPrice.price_details.netto
                          ).toFixed?.(2)}{" "}
                          {classsPrice.price_details.currency_sign}
                        </Typography>
                      </Stack>
                    )}
                  </>
                )}

                {/* {price_details.referral_balance > 0 && (
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    gap={1}
                  >
                    <Typography fontSize={"14px"} fontWeight={300}>
                      {t("referralBalance")}{" "}
                    </Typography>
                    <Typography fontSize={"14px"} fontWeight={600}>
                      - {price_details.referral_balance.toFixed?.(2)}{" "}
                      {classsPrice.price_details.currency_sign}
                    </Typography>
                  </Stack>
                )} */}
                    {/* <Divider /> */}
                    <Stack
                  gap={1}
                  py={1.5}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  borderTop={"1px solid #ECEBF2"}
                  borderBottom={"1px solid #ECEBF2"}
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    dispatch(
                      modalActions.openModal({
                        type: MODAL.APPLY_COUPON,
                        data: coupon_code ? t("change") : t("apply"),
                        width: "400px",
                      })
                    )
                  }
                >
                  <Typography
                    fontSize={"14px"}
                    fontWeight={600}
                    color={"#520A76"}
                  >
                    {coupon_code ? t("change") : t("add")}{" "}
                    {i18n.language === "ar"
                      ? `${t("coupon")} ${t("discountCoupon")}`
                      : t("coupon")}
                  </Typography>

                  <img src={PlusIcon} alt="" />
                </Stack>
                
                <Stack
                  gap={1}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography fontSize={"14px"} fontWeight={300}>
                    {t("total")} {t("price")}
                  </Typography>
                  <Typography
                    fontSize={"18px"}
                    fontWeight={700}
                    lineHeight={"18px"}
                    color={"#520A76"}
                  >
                    {price_details.total.toFixed?.(2)}{" "}
                    {classsPrice.price_details.currency_sign}
                  </Typography>
                </Stack>
              </Stack>
            </Box>

            <Box>
              <ButtonLoading
                sx={{ height: "48px", borderRadius: "25px" }}
                color="info"
                disableElevation
                size="large"
                variant="contained"
                fullWidth
                loading={submitLoader}
                onClick={() => dispatch(submit("SearchForm"))}
              >
                {t("bookNow")}
              </ButtonLoading>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <PersistReduxForm form={form} />
    </form>
  );
};

export default reduxForm({
  form: "SearchForm",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Checkout);
